import notificationTypes from '@common/constants/RenterNotificationTypes';
import {
  CREDIT_TRACKING_ENROLL_FAILURE,
  CREDIT_TRACKING_ENROLL_SUCCESS,
  CREDIT_TRACKING_UNENROLL_FAILURE,
  CREDIT_TRACKING_UNENROLL_SUCCESS,
  DEFAULT_ERROR,
  MICRODEPOSIT_FAIL,
  MICRODEPOSIT_LIMIT_REACHED,
  MICRODEPOSIT_SUCCESS,
  MOVE_IN_COSTS_PAID,
  MOVE_IN_COSTS_SCHEDULED,
  NEW_PAYMENT_METHOD_ADDED_SUCCESS,
  ONE_TIME_PAYMENT_PAID,
  PAST_DUE_WARNING_IF_PAYMENT_PLAN_AVAILABLE,
  PAYMENT_CANCEL_SUCCESS,
  PAYMENT_MARKED_PAID_BY_LANDLORD,
  PAYMENT_METHOD_DELETED_SUCCESS,
  PAYMENT_METHOD_INSUFFICIENT_FUNDS,
  PAYMENT_METHOD_UNPROCESSABLE,
  PAYMENT_METHOD_UPDATED_SUCCESS,
  PAYMENT_PAID,
  PAYMENT_PAID_OFFLINE,
  PAYMENT_PLAN_INSTALLMENT_PAID,
  PAYMENT_REPORTING_OPT_IN_SUCCESS,
  PAYMENT_REPORTING_OPT_OUT_SUCCESS,
  PAYMENT_SAVED_SUCCESS,
  PAYMENT_SCHEDULED_ALWAYS_LATE,
  PAYMENT_SCHEDULED_MAYBE_LATE,
  PAYMENT_SCHEDULED_SUCCESS,
  PAYMENT_SCHEDULED_SUCCESS_DETAILED,
  PAYMENT_TIMEOUT,
  PAYMENT_UNPROCESSABLE,
  PAYMENT_UPDATED_SUCCESS,
  PLAID_CREATE_PAYMENT_METHOD_ERROR,
  RENT_AMOUNT_CHANGE_ACCEPTED,
  RENT_AMOUNT_CHANGE_EXPIRED,
  RENT_AMOUNT_CHANGE_REMINDER,
  REVIEW_RENT_AMOUNT_CHANGE,
  VERIFY_MULTIPLE_BANK_ACCOUNTS_BANNER,
  VERIFY_SINGLE_BANK_ACCOUNT_BANNER,
} from '@renter-hub/constants/notifications';
import {
  CREDIT_TRACKING_ENROLL_FAILURE_MESSAGE,
  CREDIT_TRACKING_ENROLL_SUCCESS_MESSAGE,
  CREDIT_TRACKING_UNENROLL_FAILURE_MESSAGE,
  CREDIT_TRACKING_UNENROLL_SUCCESS_MESSAGE,
  DEFAULT_ERROR_MESSAGE,
  MICRODEPOSIT_FAIL_MESSAGE,
  MICRODEPOSIT_SUCCESS_MESSAGE,
  MOVE_IN_COSTS_PAID_MESSAGE,
  MOVE_IN_COSTS_SCHEDULED_MESSAGE,
  ONE_TIME_PAYMENT_PAID_MESSAGE,
  PAST_DUE_WARNING_IF_PAYMENT_PLAN_AVAILABLE_MESSAGE,
  PAYMENT_CANCEL_SUCCESS_MESSAGE,
  PAYMENT_METHOD_INSUFFICIENT_FUNDS_MESSAGE,
  PAYMENT_METHOD_UNPROCESSABLE_MESSAGE,
  PAYMENT_METHOD_UPDATED_SUCCESS_MESSAGE,
  PAYMENT_PAID_MESSAGE,
  PAYMENT_PAID_OFFLINE_MESSAGE,
  PAYMENT_REPORTING_OPT_IN_SUCCESS_MESSAGE,
  PAYMENT_REPORTING_OPT_OUT_SUCCESS_MESSAGE,
  PAYMENT_SAVED_SUCCESS_MESSAGE,
  PAYMENT_SCHEDULED_ALWAYS_LATE_MESSAGE,
  PAYMENT_SCHEDULED_MAYBE_LATE_MESSAGE,
  PAYMENT_SCHEDULED_SUCCESS_MESSAGE,
  PAYMENT_TIMEOUT_MESSAGE,
  PAYMENT_UNPROCESSABLE_MESSAGE,
  PAYMENT_UPDATED_SUCCESS_MESSAGE,
} from '@renter-hub/constants/notificationMessages';
import {
  MicroDepositLimitReached as MicroDepositLimitReachedComponent,
  NewPaymentMethodAdded,
  PaymentMarkedPaidByLandlord,
  PaymentMethodDeleted,
  PaymentScheduleSuccessDetailed,
  RentAmountChangeExpired,
  ReviewRentAmountChange as ReviewRentAmountChangeComponent,
  VerifyMultipleBankAccountsBanner,
  VerifySingleBankAccountBanner,
} from './customNotifications';

export default {
  [DEFAULT_ERROR]: {
    type: notificationTypes.ERROR,
    text: (): string => DEFAULT_ERROR_MESSAGE,
  },
  [PAYMENT_SAVED_SUCCESS]: {
    type: notificationTypes.SUCCESS,
    text: (): string => PAYMENT_SAVED_SUCCESS_MESSAGE,
  },
  [PAYMENT_UPDATED_SUCCESS]: {
    type: notificationTypes.SUCCESS,
    text: (): string => PAYMENT_UPDATED_SUCCESS_MESSAGE,
  },
  [NEW_PAYMENT_METHOD_ADDED_SUCCESS]: {
    custom: true,
    component: NewPaymentMethodAdded,
  },
  [PAYMENT_METHOD_UNPROCESSABLE]: {
    type: notificationTypes.ERROR,
    text: (): string => PAYMENT_METHOD_UNPROCESSABLE_MESSAGE,
  },
  [PLAID_CREATE_PAYMENT_METHOD_ERROR]: {
    type: notificationTypes.ERROR,
    text: ({ message }): string => message,
  },
  [PAYMENT_METHOD_UPDATED_SUCCESS]: {
    type: notificationTypes.SUCCESS,
    text: (): string => PAYMENT_METHOD_UPDATED_SUCCESS_MESSAGE,
  },
  [PAYMENT_METHOD_INSUFFICIENT_FUNDS]: {
    type: notificationTypes.ERROR,
    text: (): string => PAYMENT_METHOD_INSUFFICIENT_FUNDS_MESSAGE,
  },
  [PAYMENT_SCHEDULED_SUCCESS]: {
    type: notificationTypes.SUCCESS,
    text: (): string => PAYMENT_SCHEDULED_SUCCESS_MESSAGE,
  },
  [PAYMENT_SCHEDULED_SUCCESS_DETAILED]: {
    custom: true,
    type: notificationTypes.SUCCESS,
    component: PaymentScheduleSuccessDetailed,
  },
  [PAYMENT_SCHEDULED_MAYBE_LATE]: {
    type: notificationTypes.ERROR,
    text: (): string => PAYMENT_SCHEDULED_MAYBE_LATE_MESSAGE,
  },
  [PAYMENT_SCHEDULED_ALWAYS_LATE]: {
    type: notificationTypes.DEFAULT,
    text: (): string => PAYMENT_SCHEDULED_ALWAYS_LATE_MESSAGE,
  },
  [PAYMENT_PAID]: {
    type: notificationTypes.SUCCESS,
    text: (): string => PAYMENT_PAID_MESSAGE,
  },
  [PAYMENT_PAID_OFFLINE]: {
    type: notificationTypes.SUCCESS,
    text: (): string => PAYMENT_PAID_OFFLINE_MESSAGE,
  },
  [PAYMENT_MARKED_PAID_BY_LANDLORD]: {
    custom: true,
    component: PaymentMarkedPaidByLandlord,
  },
  [PAYMENT_CANCEL_SUCCESS]: {
    type: notificationTypes.SUCCESS,
    text: (): string => PAYMENT_CANCEL_SUCCESS_MESSAGE,
  },
  [MICRODEPOSIT_SUCCESS]: {
    type: notificationTypes.SUCCESS,
    text: (): string => MICRODEPOSIT_SUCCESS_MESSAGE,
  },
  [MICRODEPOSIT_FAIL]: {
    type: notificationTypes.DEFAULT,
    text: (): string => MICRODEPOSIT_FAIL_MESSAGE,
  },
  [MICRODEPOSIT_LIMIT_REACHED]: {
    custom: true,
    component: MicroDepositLimitReachedComponent,
  },
  [REVIEW_RENT_AMOUNT_CHANGE]: {
    custom: true,
    component: ReviewRentAmountChangeComponent,
  },
  [RENT_AMOUNT_CHANGE_ACCEPTED]: {
    type: notificationTypes.SUCCESS,
    text: ({ newAmountFormatted, effectiveDueDateFormatted }: Record<string, string>): string =>
      'All set. You’ve agreed to a new ' +
      `monthly rent amount of ${newAmountFormatted} (effective ${effectiveDueDateFormatted}).`,
  },
  [RENT_AMOUNT_CHANGE_REMINDER]: {
    type: notificationTypes.SUCCESS,
    text: ({ newAmountFormatted, effectiveDueDateFormatted }: Record<string, string>): string =>
      'Your new monthly rent amount ' + `of ${newAmountFormatted} will go into effect ${effectiveDueDateFormatted}.`,
  },
  [RENT_AMOUNT_CHANGE_EXPIRED]: {
    custom: true,
    component: RentAmountChangeExpired,
  },
  [PAYMENT_METHOD_DELETED_SUCCESS]: {
    custom: true,
    component: PaymentMethodDeleted,
  },
  [VERIFY_SINGLE_BANK_ACCOUNT_BANNER]: {
    custom: true,
    component: VerifySingleBankAccountBanner,
  },
  [VERIFY_MULTIPLE_BANK_ACCOUNTS_BANNER]: {
    custom: true,
    component: VerifyMultipleBankAccountsBanner,
  },
  [PAYMENT_TIMEOUT]: {
    type: notificationTypes.DEFAULT,
    text: (): string => PAYMENT_TIMEOUT_MESSAGE,
  },
  [ONE_TIME_PAYMENT_PAID]: {
    type: notificationTypes.SUCCESS,
    text: (): string => ONE_TIME_PAYMENT_PAID_MESSAGE,
  },
  [PAYMENT_PLAN_INSTALLMENT_PAID]: {
    type: notificationTypes.SUCCESS,
    text: ({ paymentPlanInstallmentTitle }: Record<string, string>): string =>
      `Done! Your ${paymentPlanInstallmentTitle} has been paid.`,
  },
  [MOVE_IN_COSTS_SCHEDULED]: {
    type: notificationTypes.SUCCESS,
    text: (): string => MOVE_IN_COSTS_SCHEDULED_MESSAGE,
  },
  [MOVE_IN_COSTS_PAID]: {
    type: notificationTypes.SUCCESS,
    text: (): string => MOVE_IN_COSTS_PAID_MESSAGE,
  },
  [PAYMENT_UNPROCESSABLE]: {
    type: notificationTypes.ERROR,
    text: (): string => PAYMENT_UNPROCESSABLE_MESSAGE,
  },
  [PAST_DUE_WARNING_IF_PAYMENT_PLAN_AVAILABLE]: {
    type: notificationTypes.DEFAULT,
    text: (): string => PAST_DUE_WARNING_IF_PAYMENT_PLAN_AVAILABLE_MESSAGE,
  },
  [PAYMENT_REPORTING_OPT_IN_SUCCESS]: {
    type: notificationTypes.SUCCESS,
    text: (): string => PAYMENT_REPORTING_OPT_IN_SUCCESS_MESSAGE,
  },
  [PAYMENT_REPORTING_OPT_OUT_SUCCESS]: {
    type: notificationTypes.INFO,
    text: (): string => PAYMENT_REPORTING_OPT_OUT_SUCCESS_MESSAGE,
  },
  [CREDIT_TRACKING_UNENROLL_SUCCESS]: {
    type: notificationTypes.INFO,
    text: (): string => CREDIT_TRACKING_UNENROLL_SUCCESS_MESSAGE,
  },
  [CREDIT_TRACKING_UNENROLL_FAILURE]: {
    type: notificationTypes.ERROR,
    text: (): string => CREDIT_TRACKING_UNENROLL_FAILURE_MESSAGE,
  },
  [CREDIT_TRACKING_ENROLL_SUCCESS]: {
    type: notificationTypes.INFO,
    text: (): string => CREDIT_TRACKING_ENROLL_SUCCESS_MESSAGE,
  },
  [CREDIT_TRACKING_ENROLL_FAILURE]: {
    type: notificationTypes.ERROR,
    text: (): string => CREDIT_TRACKING_ENROLL_FAILURE_MESSAGE,
  },
};
